import { LinearProgress } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { getMPDataWithParams } from 'src/mentor/services'
import {
  AvailabilityPageContainer,
  PageHeadlineComponent,
  PageMainContentContainer,
} from '../MentorAvailabilityPage/MentorAvailabilityPageStyles'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'

export default function MentorClinicAuditSomeChamber() {
  const navigate = useNavigate()
  const { mentorClinicAssociationData } = useContext(MentorProfileContext)
  const [loading, setLoading] = useState(false)
  const [selectedClinicId, setSelectedClinicId] = useState('')
  const [data, setData] = useState()

  async function loadAuditableChambers() {
    if (selectedClinicId) {
      setLoading(true)
      setData()
      const response = await getMPDataWithParams('/api/secure/teacher/audit/chamber-room/list', {
        clinicLocationId: selectedClinicId,
      })
      setLoading(false)
      if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
        setData(response?.data?.data)
      }
    }
  }

  useEffect(() => {
    loadAuditableChambers()
  }, [selectedClinicId])

  useEffect(() => {
    setSelectedClinicId(mentorClinicAssociationData?.[0]?.id)
  }, [])

  const thisClinicData = mentorClinicAssociationData?.find((item) => item?.id === selectedClinicId)

  return (
    <AvailabilityPageContainer>
      <PageHeadlineComponent
        heading={
          <div className="d-flex flex-column gap-2">
            <span className="fs-6">
              <CustomSelect
                value={selectedClinicId}
                options={mentorClinicAssociationData}
                getOptionValue={(optn) => optn?.id}
                getOptionLabel={(optn) => optn?.title}
                selectType={selectTypes.string}
                onChangeEvent={(e) => {
                  setSelectedClinicId(e.target.value)
                }}
              />
            </span>
          </div>
        }
      />

      <PageMainContentContainer style={{ padding: '24px' }}>
        {loading && <LinearProgress />}
        <div style={{ marginTop: '24px' }}>Auditing Screens in {thisClinicData?.name}</div>
        <div style={{ display: 'block' }}>
          You can only see the screens where the people you can audit are online.
        </div>
        <div
          style={{
            margin: '24px 0',
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)', // 3 equal columns
            gap: '8px', // Adjust as needed
            textAlign: 'center', // Center align text in the grid
          }}
        >
          <div>
            <b>Chamber Room</b>
          </div>
          <div>
            <b>Present</b>
          </div>
          <div>
            <b>Join Link</b>
          </div>
        </div>
        {data?.['chamber-room']?.map((item, idx) => {
          const channelData = data?.['chamber-room-channel']?.find(
            (channelItem) => channelItem?.chamberRoomId === item?.id,
          )
          return (
            <div
              key={idx}
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)', // 3 equal columns
                gap: '8px', // Adjust as needed
                fontSize: '12px',
                textAlign: 'center', // Center align text in the grid
              }}
            >
              <div style={{ whiteSpace: 'nowrap', wordBreak: 'break-word' }}>{item?.title}</div>
              <div style={{ whiteSpace: 'nowrap', wordBreak: 'break-word' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  {channelData?.mentorName}
                  <div
                    style={{
                      background: '#36eb2d',
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>
              <div
                style={{ whiteSpace: 'nowrap', wordBreak: 'break-word', cursor: 'pointer' }}
                onClick={() => navigate(`/mentor-home/join-as-auditor/${item?.id}/${channelData?.id}`)}
              >
                <u>Join</u>
              </div>
            </div>
          )
        })}
        {data?.['chamber-room']?.length === 0 && (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)', // 3 equal columns
              gap: '8px', // Adjust as needed
              fontSize: '12px',
              textAlign: 'center', // Center align text in the grid
            }}
          >
            <div>--</div>
            <div>--</div>
            <div>--</div>
          </div>
        )}
      </PageMainContentContainer>
    </AvailabilityPageContainer>
  )
}
